import Store from 'types/Store/PropertyManagementStore';

export const getLocalPropertyDateTime = (state: Store) =>
  state.propertyManagement.localPropertyDateTime;

export const getCurrentBusinessDate = (state: Store) =>
  state.propertyManagement.businessDate;
